import { useState, useEffect } from 'react';
import { DEFAULT_THEME_ID } from './themes';

const STORAGE_KEY = 'themeId';

/**
 * Reads/writes the active theme. Syncs to body[data-theme] and localStorage.
 * Call this once at the app root (AppShell) so it initializes immediately.
 */
export function useTheme() {
  const [themeId, setThemeIdState] = useState<string>(() => {
    // Synchronous read so there's no flash of default theme
    const saved = localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME_ID;
    document.body.dataset.theme = saved;
    return saved;
  });

  const setThemeId = (id: string) => {
    document.body.dataset.theme = id;
    localStorage.setItem(STORAGE_KEY, id);
    setThemeIdState(id);
  };

  // Re-apply on mount in case body was reset
  useEffect(() => {
    document.body.dataset.theme = themeId;
  }, [themeId]);

  return { themeId, setThemeId };
}
